import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=d675bfd0&scoped=true&"
import script from "./FileTable.vue?vue&type=script&lang=js&"
export * from "./FileTable.vue?vue&type=script&lang=js&"
import style0 from "./FileTable.vue?vue&type=style&index=0&id=d675bfd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d675bfd0",
  null
  
)

export default component.exports